(function () {
  "use strict";

  var SELECTOR = "[data-ecp]";

  function asBoolean(value) {
    return value === true || value === "true";
  }

  function PressCarousel(root) {
    if (!root || root.__ecpInstance) return;

    this.root = root;
    this.viewport = root.querySelector("[data-ecp-viewport]");
    this.track = root.querySelector("[data-ecp-track]");
    this.originals = [];
    this.originalSpan = 0;
    this.offset = 0;
    this.speed = Math.max(0, Number(root.dataset.speed) || 120);
    this.autoplay = asBoolean(root.dataset.autoplay);
    this.draggable = asBoolean(root.dataset.draggable);
    this.pauseOnHover = asBoolean(root.dataset.pauseHover);
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.hovered = false;
    this.focused = false;
    this.dragging = false;
    this.blockSelected = false;
    this.destroyed = false;
    this.lastTime = 0;
    this.raf = 0;
    this.resizeRaf = 0;
    this.pointerId = null;
    this.dragStartX = 0;
    this.dragStartOffset = 0;

    if (!this.viewport || !this.track) return;
    this.originals = Array.prototype.slice.call(this.track.querySelectorAll("[data-ecp-slide]:not([data-ecp-clone])"));
    if (!this.originals.length) return;

    root.__ecpInstance = this;
    this.bind();
    this.rebuild();
    this.tick = this.tick.bind(this);
    this.raf = window.requestAnimationFrame(this.tick);
  }

  PressCarousel.prototype.wrap = function (value) {
    if (!this.originalSpan) return 0;
    return ((value % this.originalSpan) + this.originalSpan) % this.originalSpan;
  };

  PressCarousel.prototype.render = function () {
    this.track.style.transform = "translate3d(" + (-this.offset).toFixed(3) + "px, 0, 0)";
  };

  PressCarousel.prototype.isPaused = function () {
    return (
      !this.autoplay ||
      this.reducedMotion ||
      document.hidden ||
      this.dragging ||
      this.blockSelected ||
      (this.pauseOnHover && (this.hovered || this.focused))
    );
  };

  PressCarousel.prototype.tick = function (time) {
    if (this.destroyed) return;
    if (!this.lastTime) this.lastTime = time;
    var delta = Math.min(64, time - this.lastTime);
    this.lastTime = time;

    if (!this.isPaused() && this.originalSpan > 0) {
      this.offset = this.wrap(this.offset + (this.speed * delta) / 1000);
      this.render();
    }

    this.raf = window.requestAnimationFrame(this.tick);
  };

  PressCarousel.prototype.removeClones = function () {
    Array.prototype.forEach.call(this.track.querySelectorAll("[data-ecp-clone]"), function (clone) {
      clone.remove();
    });
  };

  PressCarousel.prototype.makeClone = function (slide) {
    var clone = slide.cloneNode(true);
    clone.setAttribute("data-ecp-clone", "");
    clone.setAttribute("aria-hidden", "true");
    clone.removeAttribute("id");
    clone.removeAttribute("data-shopify-editor-block");
    clone.querySelectorAll("[id]").forEach(function (node) {
      node.removeAttribute("id");
    });
    clone.querySelectorAll("[data-shopify-editor-block]").forEach(function (node) {
      node.removeAttribute("data-shopify-editor-block");
    });
    clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(function (node) {
      node.setAttribute("tabindex", "-1");
    });
    return clone;
  };

  PressCarousel.prototype.rebuild = function () {
    var previousSpan = this.originalSpan;
    var previousProgress = previousSpan > 0 ? this.offset / previousSpan : 0;
    var self = this;

    this.removeClones();
    this.track.style.transform = "translate3d(0, 0, 0)";

    var first = this.originals[0];
    var last = this.originals[this.originals.length - 1];
    var lastStyle = window.getComputedStyle(last);
    var lastMargin = parseFloat(lastStyle.marginRight) || 0;
    this.originalSpan = last.offsetLeft + last.offsetWidth + lastMargin - first.offsetLeft;

    if (!this.originalSpan) return;

    var repeatCount = Math.max(1, Math.ceil(this.viewport.clientWidth / this.originalSpan) + 1);
    for (var repeat = 0; repeat < repeatCount; repeat += 1) {
      this.originals.forEach(function (slide) {
        self.track.appendChild(self.makeClone(slide));
      });
    }

    this.offset = this.wrap(previousProgress * this.originalSpan);
    this.render();
  };

  PressCarousel.prototype.queueRebuild = function () {
    var self = this;
    window.cancelAnimationFrame(this.resizeRaf);
    this.resizeRaf = window.requestAnimationFrame(function () {
      self.rebuild();
    });
  };

  PressCarousel.prototype.moveByOne = function (direction) {
    if (!this.originals.length) return;
    var currentStyle = window.getComputedStyle(this.originals[0]);
    var pitch = this.originals[0].offsetWidth + (parseFloat(currentStyle.marginRight) || 0);
    this.offset = this.wrap(this.offset + pitch * direction);
    this.render();
    this.lastTime = 0;
  };

  PressCarousel.prototype.onPointerDown = function (event) {
    if (!this.draggable || (event.pointerType === "mouse" && event.button !== 0)) return;
    this.dragging = true;
    this.pointerId = event.pointerId;
    this.dragStartX = event.clientX;
    this.dragStartOffset = this.offset;
    this.viewport.classList.add("is-dragging");
    if (this.viewport.setPointerCapture) this.viewport.setPointerCapture(event.pointerId);
  };

  PressCarousel.prototype.onPointerMove = function (event) {
    if (!this.dragging || event.pointerId !== this.pointerId) return;
    this.offset = this.wrap(this.dragStartOffset - (event.clientX - this.dragStartX));
    this.render();
    if (event.pointerType === "mouse") event.preventDefault();
  };

  PressCarousel.prototype.onPointerEnd = function (event) {
    if (!this.dragging || event.pointerId !== this.pointerId) return;
    this.dragging = false;
    this.pointerId = null;
    this.viewport.classList.remove("is-dragging");
    this.lastTime = 0;
  };

  PressCarousel.prototype.bind = function () {
    var self = this;

    this.onPointerDownBound = function (event) { self.onPointerDown(event); };
    this.onPointerMoveBound = function (event) { self.onPointerMove(event); };
    this.onPointerEndBound = function (event) { self.onPointerEnd(event); };
    this.onResizeBound = function () { self.queueRebuild(); };
    this.onMouseEnterBound = function () { self.hovered = true; };
    this.onMouseLeaveBound = function () { self.hovered = false; self.lastTime = 0; };
    this.onFocusInBound = function () { self.focused = true; };
    this.onFocusOutBound = function (event) {
      if (!self.root.contains(event.relatedTarget)) {
        self.focused = false;
        self.lastTime = 0;
      }
    };
    this.onKeyDownBound = function (event) {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        self.moveByOne(-1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        self.moveByOne(1);
      }
    };
    this.onDragStartBound = function (event) { event.preventDefault(); };
    this.onVisibilityBound = function () { self.lastTime = 0; };

    this.viewport.addEventListener("pointerdown", this.onPointerDownBound);
    this.viewport.addEventListener("pointermove", this.onPointerMoveBound);
    this.viewport.addEventListener("pointerup", this.onPointerEndBound);
    this.viewport.addEventListener("pointercancel", this.onPointerEndBound);
    this.viewport.addEventListener("mouseenter", this.onMouseEnterBound);
    this.viewport.addEventListener("mouseleave", this.onMouseLeaveBound);
    this.viewport.addEventListener("focusin", this.onFocusInBound);
    this.viewport.addEventListener("focusout", this.onFocusOutBound);
    this.viewport.addEventListener("keydown", this.onKeyDownBound);
    this.viewport.addEventListener("dragstart", this.onDragStartBound);
    document.addEventListener("visibilitychange", this.onVisibilityBound);
    window.addEventListener("resize", this.onResizeBound, { passive: true });

    if ("ResizeObserver" in window) {
      this.resizeObserver = new ResizeObserver(this.onResizeBound);
      this.resizeObserver.observe(this.viewport);
    }
  };

  PressCarousel.prototype.selectBlock = function (blockId) {
    var target = this.originals.find(function (slide) {
      return slide.dataset.blockId === blockId;
    });
    if (!target) return;
    this.blockSelected = true;
    this.offset = this.wrap(target.offsetLeft);
    this.render();
  };

  PressCarousel.prototype.destroy = function () {
    this.destroyed = true;
    window.cancelAnimationFrame(this.raf);
    window.cancelAnimationFrame(this.resizeRaf);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    this.viewport.removeEventListener("pointerdown", this.onPointerDownBound);
    this.viewport.removeEventListener("pointermove", this.onPointerMoveBound);
    this.viewport.removeEventListener("pointerup", this.onPointerEndBound);
    this.viewport.removeEventListener("pointercancel", this.onPointerEndBound);
    this.viewport.removeEventListener("mouseenter", this.onMouseEnterBound);
    this.viewport.removeEventListener("mouseleave", this.onMouseLeaveBound);
    this.viewport.removeEventListener("focusin", this.onFocusInBound);
    this.viewport.removeEventListener("focusout", this.onFocusOutBound);
    this.viewport.removeEventListener("keydown", this.onKeyDownBound);
    this.viewport.removeEventListener("dragstart", this.onDragStartBound);
    document.removeEventListener("visibilitychange", this.onVisibilityBound);
    window.removeEventListener("resize", this.onResizeBound);
    this.removeClones();
    this.track.style.transform = "";
    delete this.root.__ecpInstance;
  };

  function scan(scope) {
    var target = scope || document;
    if (target.matches && target.matches(SELECTOR)) new PressCarousel(target);
    if (target.querySelectorAll) {
      target.querySelectorAll(SELECTOR).forEach(function (root) {
        new PressCarousel(root);
      });
    }
  }

  if (window.ElevrClevrPressCarousel) {
    window.ElevrClevrPressCarousel.scan();
    return;
  }

  window.ElevrClevrPressCarousel = {
    scan: scan
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", function (event) {
    scan(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var roots = [];
    if (event.target.matches && event.target.matches(SELECTOR)) roots.push(event.target);
    if (event.target.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(event.target.querySelectorAll(SELECTOR)));
    }
    roots.forEach(function (root) {
      if (root.__ecpInstance) root.__ecpInstance.destroy();
    });
  });

  document.addEventListener("shopify:block:select", function (event) {
    var root = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!root || !root.__ecpInstance) return;
    root.__ecpInstance.selectBlock(event.detail && event.detail.blockId ? event.detail.blockId : event.target.dataset.blockId);
  });

  document.addEventListener("shopify:block:deselect", function (event) {
    var root = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!root || !root.__ecpInstance) return;
    root.__ecpInstance.blockSelected = false;
    root.__ecpInstance.lastTime = 0;
  });
})();
